import React from "react";
import {FaApple} from "react-icons/fa";
import {coreUrls} from "core_src/js/core_urls_config";
import classNames from 'classnames';
import {socialConfig} from "anvil_social_src/social_config";
import {Button, useBreakpointValue} from '@chakra-ui/react';
import { lighten } from '@chakra-ui/theme-tools';

/**
 * Show a styled Apple Auth button
 * @param next - URL to be redirected to after successful login
 * @param urlOverride - Navigate here instead of the normal Apple Login path.
 * @param className - Extra class names as a string to add to the surrounding div.
 * @param font - An override for the font of the button.
 * @param aTagAttributes - Any extra parameters get added to the `a` tag as attributes.
 */
export const AppleSSOButton = ({
                                   next,
                                   urlOverride,
                                   className,
                                   ...aTagAttributes
                               }) => {
    const buttonSize = useBreakpointValue({ base: 'md', md: 'lg' });

    // Only show Apple login button if it is configured
    if (!socialConfig.apple || !socialConfig.apple.enabled) {
        return null;
    }

    const classes = classNames(className);

    let href;
    if (urlOverride) {
        href = urlOverride;
        if (next) {
            console.warn("next has no effect when urlOverride is set.")
        }
    } else {
        href = coreUrls.apple_social_begin;
        if (next) {
            href += `?next=${encodeURIComponent(next)}`
        }
    }

    const hoverColor = lighten('apple.dark', 15)

    return (
        <Button
            as={"a"}
            bg={'apple.dark'}
            isFullWidth={true}
            leftIcon={<FaApple/>}
            size={buttonSize}
            color={"white"}
            _hover={{bg: hoverColor, color: "white"}}
            _active={{bg: hoverColor, color: "white"}}
            className={classes}
            href={href}
            {...aTagAttributes}
        >
            Continue with Apple
        </Button>
    )
}
